import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";
import { NotificationStateType } from "./types/notification";

const initialState: NotificationStateType = {
  id: undefined,
  open: false,
  level: "info",
  title: "",
  body: "",
  onCancelLabel: "",
  onConfirmLabel: "global:continue",
  onConfirm: undefined,
  onCancel: undefined,
  onClose: undefined,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    showNotification: (
      state: NotificationStateType,
      { payload }: PayloadAction<NotificationStateType>
    ) => {
      state.id = payload.id || undefined;
      state.open = true;
      state.level = payload.level;
      state.title = payload.title;
      state.body = payload.body;
      state.onConfirm = payload.onConfirm;
      state.onCancel = payload.onCancel;
      state.onClose = payload.onClose;
      state.onCancelLabel = payload.onCancelLabel;
      state.onConfirmLabel = payload.onConfirmLabel;
    },
    hideNotification: (state: NotificationStateType) => {
      state.id = initialState.id;
      state.level = initialState.level;
      state.title = initialState.title;
      state.body = initialState.body;
      state.onCancelLabel = initialState.onCancelLabel;
      state.onConfirmLabel = initialState.onConfirmLabel;
      state.onConfirm = initialState.onConfirm;
      state.onCancel = initialState.onCancel;
      state.onClose = initialState.onClose;
      state.open = false;
    },
  },
});

export default notificationSlice.reducer;

export const actions = notificationSlice.actions;

export const notificationSelector = (state: RootState) => state.notification;
